import { LobbyMessage, LobbyMessageType, PlayerLobbyStatus } from '@playcastdotio/Messaging';
import { hostConnectionState, invitationState2, lobbyState } from '../../stores';

export const handleLobbyMessage = (message: LobbyMessage) => {
  switch (message.type) {
    case LobbyMessageType.LOBBY_STATE_CHANGED: {
      console.log('Lobby message:', message);
      const me = message?.players?.find((player) => player.playerId === invitationState2.currentState.invitationPlayerId);
      if (me) {
        lobbyState.updateState({
          ...lobbyState.currentState,
          accepted: me.status === PlayerLobbyStatus.Accepted,
          position: me.position,
        });
      }
      lobbyState.updateState({
        ...lobbyState.currentState,
        ...message,
      });
      break;
    }
    case LobbyMessageType.LOBBY_ACCEPT_SUCCESS: {
      console.log('Lobby message:', message);
      lobbyState.updateState({
        ...lobbyState.currentState,
        accepted: true,
        broadcastHostId: message.hostPeerId,
      });
      hostConnectionState.updateState({
        ...hostConnectionState.currentState,
        broadcastSessionId: message.hostPeerId,
      });
      break;
    }
    case LobbyMessageType.LOBBY_ACCEPT_ERROR: {
      console.log('Lobby message:', message);
      break;
    }
    case LobbyMessageType.LOBBY_LEAVE_SUCCESS: {
      console.log('Lobby message:', message);
      break;
    }
    case LobbyMessageType.LOBBY_ACCEPT:
    case LobbyMessageType.LOBBY_KICK:
    case LobbyMessageType.LOBBY_KICK_SUCCESS:
    case LobbyMessageType.LOBBY_LEAVE:
    case LobbyMessageType.LOBBY_REORDER:
    case LobbyMessageType.LOBBY_REORDER_SUCCESS: {
      console.log('Lobby message:', message);
      break;
    }
  }
};
